const FormContact = {
    civilite: '',
    firstname: '',
    lastname: '',
    etat_civil: '',
    birthdate: '',
    nationalite: '',
    adresse_postale: '',
    genre: '',
    code_postal: '',
    ville: '',
    telephone: '',
    email: '',
    metier: '',
    langue_parlee: '',
    autre_telephone: '',
    num_personne_foyer: '',
    secteur_gf: '',
    source_id: 1,
    invite_par: '',
    subscription_date: '',
    conseiller_nc: '',
    est_candidat_prog31: Boolean,
    est_converti_cec: Boolean,
    est_candidat_visite: Boolean,
    observations: '',
    est_mineur: false,
    is_acive: false,
}

export {
    FormContact
}